import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { GiBrain } from 'react-icons/gi';

function LoadingSpinner() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center">
      <div className="text-center">
        <div className="bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 p-8 rounded-3xl shadow-2xl mb-6 animate-pulse">
          <SafeIcon icon={GiBrain} className="text-white text-8xl animate-bounce" />
        </div>
        <h2 className="text-3xl font-bold bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 bg-clip-text text-transparent mb-4">
          Caricamento Mindset Supremo...
        </h2>
        <div className="flex justify-center space-x-2">
          <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-pink-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
          <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
        </div>
      </div>
    </div>
  );
}

export default LoadingSpinner;